//
import React, { Component } from "react"

import {
    datePickerGenericFilter,
    textGenericFilter,
    // sorting functions
    enumValueSort,
    searchifySelectZipCodesFilter,
} from "shared/search/containers/Filter/Filters"
import {
    enumGenericFilter,
    searchifySelectGenericFilter,
    searchifySelectStringFilter,
} from "shared/search/containers/Filter/FilterCreators"

import { isValidAmountStringNegative } from "shared/imports/sharedHelperFunctions"
import { MAX_BILL_SEARCHIFY_SELECTIONS } from "shared/search/constants"
import {
    CampaignFinanceReceiptsCandidatesFilterableListViewFLVs,
    CampaignFinanceReceiptsFilterableListView,
    PoliticalCommitteeCampaignFinanceFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"
import {
    ReceiptsCandidateSelect,
    IndividualContributorEmployerSelect,
    IndividualContributorOccupationSelect,
    IndividualContributorCitySelect,
    IndividualContributorZipCodeSelect,
    IndividualContributorStateSelect,
    PoliticalCommitteeCampaignFinanceSelect,
    PoliticalCommitteeSelect,
} from "app/static/frontend/selects/containers/PieSelect"
import { getBillSupportedRegionOptions } from "shared/selects/helperFunctions"
import { ReceiptsSupportedRegionSelect } from "app/static/frontend/selects/containers/EnumSelect"
import { usRegions } from "shared/imports/regionConstants"

export class ReceiptsTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "recipientType",
        filterKey: "recipientTypes",
        enumItems: [
            {
                fa5_icon: "minus",
                key: "refund_given",
                label: "Presidential committees",
                pac_label: "Presidential committees",
                value: "presidential",
            },
            {
                fa5_icon: "minus",
                key: "refund_given",
                label: "Senate committees",
                pac_label: "Senate committees",
                value: "senate",
            },
            {
                fa5_icon: "minus",
                key: "house",
                label: "House committees",
                pac_label: "House committees",
                value: "house",
            },
            {
                fa5_icon: "minus",
                key: "party",
                label: "Party committees",
                pac_label: "Party committees",
                value: "party",
            },
            {
                fa5_icon: "minus",
                key: "pac",
                label: "PACs",
                pac_label: "PACs",
                value: "pac",
            },
            {
                fa5_icon: "minus",
                key: "super_pac",
                label: "Super PACs",
                pac_label: "Super PACs",
                value: "super_pac",
            },
            {
                fa5_icon: "minus",
                key: "leadership_pac",
                label: "Leadership PACs",
                pac_label: "Leadership PACs",
                value: "leadership_pac",
            },
            {
                fa5_icon: "minus",
                key: "joint_fundraising_committee",
                label: "Joint Fundraising Committees (JFCs)",
                pac_label: "Joint Fundraising Committees (JFCs)",
                value: "joint_fundraising_committee",
            },
            {
                fa5_icon: "minus",
                key: "527_org",
                label: "527 Orgs",
                pac_label: "527 Orgs",
                value: "527_org",
            },
            {
                fa5_icon: "minus",
                key: "other",
                label: "Other",
                pac_label: "Other",
                value: "other",
            },
        ],
        displayKey: "pac_label",
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsPartiesFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "recipientParty",
        filterKey: "recipientParties",
        enumItems: [
            {
                key: "republican",
                label: "Republican",
                value: "republican",
            },
            {
                key: "democrat",
                label: "Democrat",
                value: "democrat",
            },
            {
                key: "other",
                label: "Other",
                value: "other",
            },
        ],
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsContributorTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "contributorType",
        filterKey: "contributorTypes",
        enumItems: [
            {
                fa5_icon: "minus",
                key: "political_party_committees",
                label: "Political party committees",
                pac_label: "Political party committees",
                value: "party",
            },
            {
                fa5_icon: "minus",
                key: "other_political_committees",
                label: "Other political committees",
                pac_label: "Other political committees",
                value: "other_campaign_committees",
            },
            {
                fa5_icon: "minus",
                key: "candidate",
                label: "Candidate",
                pac_label: "Candidate",
                value: "candidate",
            },
            {
                fa5_icon: "minus",
                key: "other_receipts",
                label: "Other receipts",
                pac_label: "Other receipts",
                value: "other",
            },
        ],
        displayKey: "pac_label",
        sortBy: enumValueSort,
        key: "key",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsElectionTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "electionType",
        filterKey: "electionsType",
        enumItems: [
            {
                fa5_icon: "minus",
                key: "primary",
                label: "Primary",
                pac_label: "Primary",
                value: "primary",
            },
            {
                fa5_icon: "minus",
                key: "general_elections",
                label: "General",
                pac_label: "General",
                value: "general",
            },
            {
                fa5_icon: "minus",
                key: "special_elections",
                label: "Special",
                pac_label: "Special",
                value: "special",
            },
            {
                fa5_icon: "minus",
                key: "other_elections",
                label: "Other",
                pac_label: "Other",
                value: "other",
            },
        ],
        displayKey: "pac_label",
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsDateStartFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "receiptsDateStart",
        filterKey: "dateStart",
        displayLabel: "Date From",
        helpText: "Receipts start date.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsDateEndFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "receiptsDateEnd",
        filterKey: "dateEnd",
        displayLabel: "Date To",
        helpText: "Receipts end date.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const ReceiptsCommitteesFilterInternal = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={PoliticalCommitteeCampaignFinanceFilterableListView} {...props} />
}

ReceiptsCommitteesFilterInternal.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "ReceiptsCommitteesFilterInternal",
    filterKey: "political_committee_receipts_cf",
    dataTypeLabel: "Political Committees",
    displayLabel: "Political Committees",
    selectComponent: PoliticalCommitteeCampaignFinanceSelect,
}

export class ReceiptsStatesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: enumGenericFilter,
            uniqueFilterId: "receiptsStatesFilter",
            filterKey: "recipientStateCodes",
            dataTypeLabel: "ReceiptRecipientState",
            searchifyFLV: CampaignFinanceReceiptsFilterableListView,
            selectComponent: IndividualContributorStateSelect,
            displayLabel: "Recipient Committee State",
            enumItems: DjangIO.app.models.Region.items()
                .filter((item) => item.is_state_region)
                .map((region) => ({ value: region.abbrev.toUpperCase(), label: region.region_name })),
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsContactsFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            dataTypeLabel: "ReceiptContacts",
            searchifyFLV: PoliticalCommitteeCampaignFinanceFilterableListView,
            selectComponent: PoliticalCommitteeCampaignFinanceSelect,
            displayLabel: "Contacts",
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsDateAfterFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "receiptDateAfter",
        filterKey: "introduced_date__gt",
        noFuture: true,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const ReceiptsSupportedRegionsFilter = (props) => {
    const FilterComponent = props.filterComponent

    return <FilterComponent {...props} />
}
ReceiptsSupportedRegionsFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    enumItems: getBillSupportedRegionOptions(),
    uniqueFilterId: "receiptsStatesFilter",
    filterKey: "recipientStateCodes",
    selectComponent: ReceiptsSupportedRegionSelect,
    regions: usRegions,
}

export class ReceiptsDateBeforeFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "receiptsDateBefore",
        filterKey: "introduced_date__lt",
        noFuture: true,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const ReceiptsContributorCommitteesFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={PoliticalCommitteeCampaignFinanceFilterableListView} {...props} />
}

ReceiptsContributorCommitteesFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "ReceiptsContributorCommitteesFilter",
    filterKey: "political_committee_disbursements_cf",
    dataTypeLabel: "Political Committees",
    displayLabel: "Political Committees",
    selectComponent: PoliticalCommitteeCampaignFinanceSelect,
}

export class ReceiptsContributorEmployersFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectStringFilter,
            uniqueFilterId: "receiptsContributorEmployersFilter",
            filterKey: "receipts_contributor_employers",
            dataTypeLabel: "ReceiptContributorEmployer",
            searchifyFLV: CampaignFinanceReceiptsFilterableListView,
            selectComponent: IndividualContributorEmployerSelect,
            displayLabel: "Employer",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsContributorOccupationsFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "ReceiptsContributorOccupationsFilter",
            filterKey: "receipts_contributor_occupations",
            dataTypeLabel: "ReceiptContributorOccupation",
            searchifyFLV: CampaignFinanceReceiptsFilterableListView,
            selectComponent: IndividualContributorOccupationSelect,
            displayLabel: "Occupation",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsContributorCitiesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "ReceiptsContributorCitiesFilter",
            filterKey: "receipts_contributor_cities",
            dataTypeLabel: "ReceiptContributorCity",
            searchifyFLV: CampaignFinanceReceiptsFilterableListView,
            selectComponent: IndividualContributorCitySelect,
            displayLabel: "City",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsContributorZipCodesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectZipCodesFilter,
            uniqueFilterId: "ReceiptsContributorZipCodesFilter",
            filterKey: "receipts_contributor_zip_codes",
            dataTypeLabel: "ReceiptContributorZipCode",
            searchifyFLV: CampaignFinanceReceiptsFilterableListView,
            selectComponent: IndividualContributorZipCodeSelect,
            displayLabel: "Zip Code",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsContributorStatesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: enumGenericFilter,
            uniqueFilterId: "ReceiptsContributorStatesFilter",
            filterKey: "receipts_state_codes",
            dataTypeLabel: "ReceiptContributorState",
            searchifyFLV: CampaignFinanceReceiptsFilterableListView,
            selectComponent: IndividualContributorStateSelect,
            displayLabel: "State",
            enumItems: DjangIO.app.models.Region.items()
                .filter((item) => item.is_state_region)
                .map((region) => ({ value: region.abbrev.toUpperCase(), label: region.region_name })),
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsCandidatesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "receiptsCandidatesFilter",
            filterKey: "receipts_candidate_name",
            dataTypeLabel: "ReceiptCandidates",
            searchifyFLV: CampaignFinanceReceiptsCandidatesFilterableListViewFLVs,
            selectComponent: ReceiptsCandidateSelect,
            displayLabel: "Candidates",
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsAmountMinFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "receiptsAmountMin",
        filterKey: "amountMin",
        placeholderText: "$0.00",
        keyboardType: "numeric",
        shouldValidateInput: true,
        validateTextInput: isValidAmountStringNegative,
        displayLabel: "Amount min",
        helpText: "Receipts amount min.",
        errorMessage: "Please enter a valid number amount.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceiptsAmountMaxFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "receiptsAmountMax",
        filterKey: "amountMax",
        placeholderText: "$0.00",
        keyboardType: "numeric",
        shouldValidateInput: true,
        displayLabel: "Amount max",
        validateTextInput: isValidAmountStringNegative,
        helpText: "Receipts amount max.",
        errorMessage: "Please enter a valid number amount.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
